window.theme.block('listing-roteiros-grupos', el => {
    const filtroTogglers = el.querySelectorAll('.filtro .toggler');
    const filtrosAll = el.querySelectorAll('.filtro');
    const optionsContainers = el.querySelectorAll('.filtro .options');

    const updateTogglerText = (filtroEl) => {
        const toggler = filtroEl.querySelector('.toggler');
        const selectedCount = filtroEl.querySelectorAll('input[type="checkbox"]:checked').length;
        if (toggler) toggler.textContent = selectedCount ? `${selectedCount} selecionado(s)` : 'Selecione';
    };

    const urlParams = new URLSearchParams(window.location.search);

    filtrosAll.forEach(filtro => {
        const checkboxes = filtro.querySelectorAll('input[type="checkbox"]');

        // Pre-check based on URL params
        checkboxes.forEach(checkbox => {
            const paramValues = urlParams.getAll(checkbox.name);
            if (paramValues.includes(checkbox.value)) checkbox.checked = true;
        });

        // Initial label sync
        updateTogglerText(filtro);

        // Update label on change
        checkboxes.forEach(checkbox => {
            checkbox.addEventListener('change', () => updateTogglerText(filtro));
        });
    });

    filtroTogglers.forEach(toggler => {
        toggler.addEventListener('click', () => {
            const parentFiltro = toggler.closest('.filtro');
            const isActive = parentFiltro.classList.contains('active');
            filtrosAll.forEach(filtro => filtro.classList.remove('active'));
            if (!isActive) parentFiltro.classList.add('active');
        });
    });

    document.addEventListener('mouseup', e => {
        let clickedInside = false;

        filtroTogglers.forEach(toggler => {
            if (toggler.contains(e.target)) clickedInside = true;
        });

        optionsContainers.forEach(options => {
            if (options.contains(e.target)) clickedInside = true;
        });

        if (!clickedInside) {
            filtrosAll.forEach(filtro => filtro.classList.remove('active'));
        }
    });

    const toggler = el.querySelector('.toggler-filters');
    const form = el.querySelector('.form');

    if (toggler && form) {
        toggler.addEventListener('click', () => {
            toggler.classList.toggle('active');
            form.classList.toggle('active');

            const textElement = toggler.querySelector('.text');
            if (textElement) {
                textElement.textContent = toggler.classList.contains('active')
                    ? 'FECHAR FILTROS'
                    : 'ABRIR FILTROS';
            }
        });
    }
});
